/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_CookiesInputs */

const en_footer_cookies = /** @type {(inputs: Footer_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies`)
};

const pl_footer_cookies = /** @type {(inputs: Footer_CookiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies`)
};

/**
* | output |
* | --- |
* | "Cookies" |
*
* @param {Footer_CookiesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_cookies = /** @type {((inputs?: Footer_CookiesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CookiesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_footer_cookies(inputs)
	return en_footer_cookies(inputs)
});